/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Chip,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import { CircularProgress } from "@mui/material";
import { CRUDFormPageProps, Role } from "../../types";
import { BASE_API_URL } from "../../API/Base";
import AxiosInstance from "../../API/axios";
import axios from "axios";
import Layout from "../../Components/Layout";
import CustomerDataModal from "../../Modals/CustomerDataModal";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const CRUDForm: React.FC<CRUDFormPageProps> = ({ mode, data, fields }) => {
  const [roles, setRoles] = useState<any>([]);
  const [customers, setCustomers] = useState<any>([]);
  const [userStatus, setUserStatus] = useState<any>(null);
  const [isCustomerModalOpen, setIsCustomerModalOpen] =
    useState<boolean>(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [selectedStatus, setSelectedStatus] = useState<any>(null);
  const [editedValues, setEditedValues] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const [formData, setFormData] = useState({
    Id: "",
    User_Name: "",
    Email_Id: "",
    Mobile_No: "",
    IsStatus: "active",
    Password: "",
    User_Type: "",
    Role_Id: [] as number[], // Change the type to string[]
  });

  const [errors, setErrors] = useState({
    User_Name: "",
    Email_Id: "",
    Mobile_No: "",
    Password: "",
    Role_Id: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  // const permissions = usePagePermissions(3);
  // const theme: Theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    fetchData();
    // fetchCustomerData();
    fetchStatusType();
  }, []);

  useEffect(() => {
    if (mode === "edit" && data) {
      setEditedValues(data);

      setFormData({
        Id: data.Id || "",
        User_Name: data.User_Name || "",
        Email_Id: data.Email_Id || "",
        Mobile_No: data.Mobile_No || "",
        IsStatus: data.IsStatus || "",
        Password: data.Password || "",
        User_Type: data.User_Type_Name || "",
        Role_Id: data.Role_Id || [],
      });

      setSelectedRoles(data.Role_Names || []);
      setSelectedCustomer(data.Customer_Name);
      setSelectedStatus(data.IsStatus);
    }
  }, [mode, data]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await AxiosInstance.get(
        `${BASE_API_URL}/admin/roles/v1/get-all-roles`
      );
      const data: Role[] = response.data;
      setRoles(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  // const fetchCustomerData = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await AxiosInstance.get(
  //       `${BASE_API_URL}/admin/v1/customer-details`
  //     );
  //     const data = response.data;
  //     setCustomers(data);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setLoading(false);
  //   }
  // };

  const fetchStatusType = async () => {
    try {
      setLoading(true);
      const response = await AxiosInstance.get(
        `${BASE_API_URL}/admin/users/v1/get-user-type`
      );
      const data = response.data;
      setUserStatus(data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleInputChange = (field: string, value: string | any) => {
    const updateState = (field: string, value: any) => {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
      setEditedValues((prevValues: any) => ({
        ...prevValues,
        [field]: value,
      }));
    };

    if (typeof value === "object" && value !== null) {
      // Handle the case when a value is selected from the modal
      updateState(field, value.Id);

      if (field === "Role_Id") {
        setSelectedRoles(value);
      } else if (field === "User_Type") {
        updateState(field, value.Status_Name);
      } else if (field === "IsStatus") {
        updateState(field, value === "true" ? 1 : 0);
      }
    } else {
      if (field === "Role_Id") {
        setSelectedRoles(value);
      } else if (field === "IsStatus") {
        updateState(field, value === "true" ? 1 : 0);
      } else {
        updateState(field, value);
      }
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      User_Name: "",
      Email_Id: "",
      Mobile_No: "",
      Password: "",
      Role_Id: "",
    };

    // Validate User_Name
    if (!formData.User_Name) {
      newErrors.User_Name = "Username is required";
      isValid = false;
    } else if (formData.User_Name.length < 3) {
      newErrors.User_Name = "Invalid Username";
      isValid = false;
    }

    // Validate Email_Id
    if (!formData.Email_Id) {
      newErrors.Email_Id = "Email Id is required";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.Email_Id)) {
      newErrors.Email_Id = "Invalid Email Id";
      isValid = false;
    }

    // Validate Mobile_No
    if (!formData.Mobile_No) {
      newErrors.Mobile_No = "Mobile No is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.Mobile_No)) {
      newErrors.Mobile_No = "Invalid Mobile No";
      isValid = false;
    }

    // Validate Password
    if (mode === "create" && !formData.Password) {
      newErrors.Password = "Password is required";
      isValid = false;
    } else if (mode === "create" && formData.Password.length < 8) {
      newErrors.Password = "Password should be at least 8 characters long";
      isValid = false;
    }

    // Validate Role_Id
    if (!formData.Role_Id || formData.Role_Id.length === 0) {
      newErrors.Role_Id = "Role is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    try {
      if (!validateForm()) {
        return;
      }
      if (mode === "create") {
        const newData = {
          Email_Id: formData.Email_Id,
          User_Name: formData.User_Name,
          Mobile_No: formData.Mobile_No,
          IsStatus: formData.IsStatus ? 1 : 0,
          Password: formData.Password,
          User_Type: userStatus.find(
            (status: any) => status.Status_Name === formData.User_Type
          )?.Id,
          Role_Id: formData.Role_Id || [],
        };

        console.log("newData", newData);

        const response = await AxiosInstance.post(
          `${BASE_API_URL}/admin/users/v1/add-users`,
          newData
        );

        if (response.data) {
          toast.success("User created successfully");
          setFormData({
            Id: "",
            User_Name: "",
            Email_Id: "",
            Mobile_No: "",
            Password: "",
            User_Type: "",
            Role_Id: [],
            IsStatus: "true",
          });
        } else {
          console.log("Error creating user:", response.data.error);
        }
      } else if (mode === "edit") {
        const roleIds =
          Array.isArray(editedValues.Role_Id) &&
          editedValues.Role_Id.every((id: any) => typeof id === "number")
            ? editedValues.Role_Id
            : typeof editedValues.Role_Id === "string"
            ? JSON.parse(editedValues.Role_Id)
            : [editedValues.Role_Id];

        const newData = {
          User_Name: editedValues.User_Name as string,
          Email_Id: editedValues.Email_Id as string,
          Mobile_No: editedValues.Mobile_No as string,
          Password: editedValues.Password as string,
          IsStatus: editedValues.IsStatus,
          User_Type: (userStatus.find(
            (status: any) => status.Status_Name === editedValues.User_Type
          )?.Id || editedValues.User_Type) as number,
          Role_Id: roleIds,
        };

        const response = await AxiosInstance.put(
          `${BASE_API_URL}/admin/users/v1/users/${editedValues.Id}`,
          newData
        );

        if (response.data) {
          toast.success("User updated successfully");
        }
      }
    } catch (error: any) {
      if (error.response) {
        console.error("Error response:", error.response);
        switch (error.response.status) {
          case 400:
            toast.error(error.response.data.detail || "Bad Request");
            break;
          case 404:
            console.error("Not Found: ", {
              url: error.response.config.url,
              method: error.response.config.method,
              data: error.response.config.data,
            });
            toast.error(
              "Requested resource not found (404). Please check the URL and try again."
            );
            break;
          default:
            toast.error(`Server Error: ${error.response.status}`);
            break;
        }
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from the server");
      } else {
        console.error("Error message:", error.message);
        toast.error("Error setting up the request");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = (
    event: React.SyntheticEvent,
    newValue: string[] | null
  ) => {
    setSelectedRoles(newValue || []);

    // Fetch corresponding role IDs for the selected role names
    const roleIds = (newValue || []).map((roleName) => {
      const role = roles.find((r: any) => r.Role_Name === roleName);
      return role ? role.Id : null; // Keep it as a number
    });

    // Remove null values and update Role_Id in editedValues
    setEditedValues((prevValues: any) => ({
      ...prevValues,
      Role_Id: roleIds.filter((id) => id !== null),
    }));

    // Update Role_Id in formData
    setFormData((prevData) => ({
      ...prevData,
      Role_Id: roleIds.filter((id) => id !== null),
    }));
  };

  const handleSelectedCustomer = (selectedCustomer: any) => {
    setIsCustomerModalOpen(false);
    setSelectedCustomer(selectedCustomer);

    handleInputChange("Customer_Id", selectedCustomer.Id);
  };

  return (
    <Layout PageId={3}>
      <CustomerDataModal
        isOpen={isCustomerModalOpen}
        onClose={() => setIsCustomerModalOpen(false)}
        onSelectedCustomer={handleSelectedCustomer}
      />
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            zIndex: 1000,
          }}
        >
          <CircularProgress size={50} />
        </Box>
      )}

      <div className="flex flex-col items-start justify-start w-full mt-4">
        <Grid container spacing={2}>
          {mode === "create" && (
            <>
              <Grid item xs={6}>
                <TextField
                  label="Username"
                  variant="outlined"
                  fullWidth
                  required
                  margin="dense"
                  size="small"
                  value={formData.User_Name}
                  onChange={(e) =>
                    handleInputChange("User_Name", e.target.value)
                  }
                  error={!!errors.User_Name}
                  helperText={errors.User_Name}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Email ID"
                  variant="outlined"
                  type="email"
                  fullWidth
                  required
                  margin="dense"
                  size="small"
                  value={formData.Email_Id}
                  onChange={(e) =>
                    handleInputChange("Email_Id", e.target.value)
                  }
                  error={!!errors.Email_Id}
                  helperText={errors.Email_Id}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Mobile Number"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  size="small"
                  required
                  onChange={(e) =>
                    handleInputChange("Mobile_No", e.target.value)
                  }
                  value={formData.Mobile_No}
                  error={!!errors.Mobile_No}
                  helperText={errors.Mobile_No}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Password"
                  variant="outlined"
                  type="password"
                  fullWidth
                  margin="dense"
                  size="small"
                  required
                  onChange={(e) =>
                    handleInputChange("Password", e.target.value)
                  }
                  value={formData.Password}
                  error={!!errors.Password}
                  helperText={errors.Password}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                >
                  <InputLabel>User type</InputLabel>
                  <Select
                    value={formData.User_Type || ""}
                    label="User type"
                    margin="dense"
                    size="small"
                    required
                    onChange={(e) =>
                      handleInputChange("User_Type", e.target.value as string)
                    }
                  >
                    {userStatus &&
                      userStatus.map((status: any) => (
                        <MenuItem value={status.Status_Name} key={status.Id}>
                          {status.Status_Name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  id="role-select"
                  options={roles.map((role: any) => role.Role_Name)}
                  value={selectedRoles}
                  onChange={handleRoleChange}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        backgroundColor: selected ? "#e0f7fa" : "white",
                      }}
                    >
                      {option}
                    </li>
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option}
                        {...getTagProps({ index })}
                        sx={{ marginRight: 0.5 }}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Roles"
                      variant="outlined"
                      fullWidth
                      size="small"
                      margin="dense"
                      required
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        "& .MuiInputLabel-root": {
                          color: "#000",
                          "&.Mui-focused": {
                            color: "#000",
                          },
                        },
                        "& .MuiInputLabel-shrink": {
                          color: "#00A99D",
                        },
                        "& .MuiOutlinedInput-root": {
                          // "& fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },
                          // "&:hover fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },

                          "& .MuiInputBase-input": {
                            color: "#000",
                            fontSize: "14px",
                          },
                          "& .MuiSelect-icon": {
                            fill: "#000 !important",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors.Role_Id && (
                  <Typography variant="caption" color="error">
                    {errors.Role_Id}
                  </Typography>
                )}
              </Grid>
            </>
          )}
          {mode === "view" && (
            <>
              {fields.map(({ label, key, type }) => (
                <Grid item xs={key === "Role_Names" ? 12 : 6} key={key}>
                  {key === "Role_Names" ? (
                    <Autocomplete
                      multiple
                      id="role-select-view"
                      options={roles.map((role: any) => role.Role_Name)}
                      value={data[key]}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip label={option} {...getTagProps({ index })} />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={label}
                          variant="outlined"
                          fullWidth
                          margin="dense"
                          size="small"
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "10px",
                            "& .MuiInputLabel-root": {
                              color: "#000",
                              "&.Mui-focused": {
                                color: "#000",
                              },
                            },
                            "& .MuiInputLabel-shrink": {
                              color: "#00A99D",
                            },
                            "& .MuiOutlinedInput-root": {
                              // "& fieldset": {
                              //   borderColor:  "#00A99D" : "",
                              // },
                              // "&:hover fieldset": {
                              //   borderColor:  "#00A99D" : "",
                              // },

                              "& .MuiInputBase-input": {
                                color: "#000",
                                fontSize: "14px",
                              },
                              "& .MuiSelect-icon": {
                                fill: "#000 !important",
                              },
                            },
                          }}
                        />
                      )}
                    />
                  ) : key === "Password" ? (
                    <TextField
                      key={key}
                      label={label}
                      variant="outlined"
                      margin="dense"
                      size="small"
                      fullWidth
                      type="password"
                      value={data[key]}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        "& .MuiInputLabel-root": {
                          color: "#000",
                          "&.Mui-focused": {
                            color: "#000",
                          },
                        },
                        "& .MuiInputLabel-shrink": {
                          color: "#00A99D",
                        },
                        "& .MuiOutlinedInput-root": {
                          // "& fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },
                          // "&:hover fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },

                          "& .MuiInputBase-input": {
                            color: "#000",
                            fontSize: "14px",
                          },
                          "& .MuiSelect-icon": {
                            fill: "#000 !important",
                          },
                        },
                      }}
                    />
                  ) : (
                    <TextField
                      key={key}
                      label={label}
                      variant="outlined"
                      margin="dense"
                      size="small"
                      fullWidth
                      value={data[key]}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        "& .MuiInputLabel-root": {
                          color: "#000",
                          "&.Mui-focused": {
                            color: "#000",
                          },
                        },
                        "& .MuiInputLabel-shrink": {
                          color: "#00A99D",
                        },
                        "& .MuiOutlinedInput-root": {
                          // "& fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },
                          // "&:hover fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },

                          "& .MuiInputBase-input": {
                            color: "#000",
                            fontSize: "14px",
                          },
                          "& .MuiSelect-icon": {
                            fill: "#000 !important",
                          },
                        },
                      }}
                    />
                  )}
                </Grid>
              ))}
            </>
          )}

          {mode === "edit" && (
            <>
              <Grid item xs={6}>
                <TextField
                  label="Email"
                  variant="outlined"
                  size="small"
                  margin="dense"
                  fullWidth
                  value={formData.Email_Id || ""}
                  error={!!errors.Email_Id}
                  helperText={errors.Email_Id}
                  disabled
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                ></TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Username"
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                  value={formData.User_Name || ""}
                  onChange={(e) =>
                    handleInputChange("User_Name", e.target.value)
                  }
                  error={!!errors.User_Name}
                  helperText={errors.User_Name}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                ></TextField>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Mobile No"
                  size="small"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={formData.Mobile_No || ""}
                  onChange={(e) =>
                    handleInputChange("Mobile_No", e.target.value)
                  }
                  error={!!errors.Mobile_No}
                  helperText={errors.Mobile_No}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                ></TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Password"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  margin="dense"
                  size="small"
                  required
                  onChange={(e) =>
                    handleInputChange("Password", e.target.value)
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleTogglePasswordVisibility}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOff sx={{ fontSize: 18 }} />
                          ) : (
                            <Visibility sx={{ fontSize: 18 }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={formData.Password || ""}
                  error={!!errors.Password}
                  helperText={errors.Password}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  id="role-select"
                  options={roles.map((role: any) => role.Role_Name)}
                  size="small"
                  value={selectedRoles}
                  onChange={handleRoleChange}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip label={option} {...getTagProps({ index })} />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Roles"
                      variant="outlined"
                      size="small"
                      margin="dense"
                      fullWidth
                      required
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        "& .MuiInputLabel-root": {
                          color: "#000",
                          "&.Mui-focused": {
                            color: "#000",
                          },
                        },
                        "& .MuiInputLabel-shrink": {
                          color: "#00A99D",
                        },
                        "& .MuiOutlinedInput-root": {
                          // "& fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },
                          // "&:hover fieldset": {
                          //   borderColor:  "#00A99D" : "",
                          // },

                          "& .MuiInputBase-input": {
                            color: "#000",
                            fontSize: "14px",
                          },
                          "& .MuiSelect-icon": {
                            fill: "#000 !important",
                          },
                        },
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="dense"
                  required
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                >
                  <InputLabel>User type</InputLabel>
                  <Select
                    value={formData.User_Type || ""}
                    label="User type"
                    required
                    onChange={(e) =>
                      handleInputChange("User_Type", e.target.value)
                    }
                  >
                    {userStatus &&
                      userStatus.map((status: any) => (
                        <MenuItem value={status.Status_Name} key={status.Id}>
                          {status.Status_Name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="dense"
                  required
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    "& .MuiInputLabel-root": {
                      color: "#000",
                      "&.Mui-focused": {
                        color: "#000",
                      },
                    },
                    "& .MuiInputLabel-shrink": {
                      color: "#00A99D",
                    },
                    "& .MuiOutlinedInput-root": {
                      // "& fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },
                      // "&:hover fieldset": {
                      //   borderColor:  "#00A99D" : "",
                      // },

                      "& .MuiInputBase-input": {
                        color: "#000",
                        fontSize: "14px",
                      },
                      "& .MuiSelect-icon": {
                        fill: "#000 !important",
                      },
                    },
                  }}
                >
                  <InputLabel>Status</InputLabel>
                  <Select
                    label="Status"
                    required
                    value={formData.IsStatus ? "true" : "false"}
                    onChange={(e) =>
                      handleInputChange("IsStatus", e.target.value as string)
                    }
                  >
                    <MenuItem value={"true"}>Active</MenuItem>
                    <MenuItem value={"false"}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}
        </Grid>
        <div className="flex flex-row items-center justify-between w-full mt-4">
          {mode === "create" && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{ color: "#fff" }}
            >
              {" "}
              Submit{" "}
            </Button>
          )}
          {mode === "edit" && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{ color: "#fff" }}
            >
              {" "}
              Save Changes{" "}
            </Button>
          )}
          <Button
            variant="outlined"
            sx={{
              color: "#000",
              border: "1px solid #000",
            }}
            onClick={() => navigate("/user/manage")}
          >
            Back
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default CRUDForm;
